<template>
    <div class="content" @click="closeTimeSelect($event)">
        <el-form ref="form" :model="dioForm" :rules="rules" label-width="150px">
            <el-form-item :label="$t('public.trigger')" prop="name">
                <el-input v-model.trim="dioForm.name" style="width: 250px" maxlength="50"></el-input>
                <i class="el-icon-back" style="float:right" @click="goBack" v-show="editForm"></i>
            </el-form-item>
            <el-form-item v-if="$store.state.type === 3 || $store.state.type === 2" :label="$t('labelTitle.Range')"
                prop="sceneId">
                <el-select style="width: 250px" v-model="dioForm.sceneId" @change="changeRangeFn"
                    @visible-change="visibleChange">
                    <el-option v-for="item in rangeArray" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('alarm.alarm_cause')" prop="reason">
                <el-checkbox-group v-model="dioForm.reason">
                    <div class="reasonClass">
                        <div class="reasonRontent" v-for="(item, index) in reasonArray" :key="index">
                            <div class="textDiv">
                                {{ item.label }}
                            </div>
                            <div class="m5">
                                <el-checkbox v-model="item.reason" :label="item.type" @change="changeFn($event, item)">
                                    <br />
                                </el-checkbox>
                            </div>
                        </div>
                    </div>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item :label="$t('alarm.alarmTime')" prop="alarmTime">
                <!-- 这里的for循环  先不绑定id为key -->
                <div v-for="(item, j) in dioForm.alarmTriggerTimeList" :key="j" class="alarmTime"
                    :class="j === 0 ? '' : 'mt38'">
                    <el-select v-model="item.alarmTime" :placeholder="$t('public.please')" style="width:100px;height:34px">
                        <el-option v-for="item in weekDay" :key="item.value" :label="$t(item.label)" :value="item.value">
                        </el-option>
                    </el-select>
                    <div class="timePoint">
                        <div class="pointContent">
                            <div class="m5" v-for="(option, k) in item.alarmTimeList" :key="k + 'k'">
                                <span class="time">
                                    {{ option.time ? option.time[0] : '' }}
                                </span>
                                <span class="to">
                                    To
                                </span>
                                <span class=" time">
                                    {{ option.time ? option.time[1] : '' }}
                                </span>
                                <span class="editTime">
                                    <i class="el-icon-caret-bottom" @click="editHandleFn(option, j, k)"></i>

                                    <el-time-picker class="timeChooze" v-show="option.isChoozeTime"
                                        style="width:250px;z-index: 999;" is-range v-model="option.time" format="HH:mm"
                                        value-format="HH:mm" :range-separator="$t('public.to')"
                                        :start-placeholder="$t('public.start_time')"
                                        :end-placeholder="$t('public.end_time')"
                                        :placeholder="$t('integration.select_a_time_range')" :ref="`pickers${j}_${k}`">
                                    </el-time-picker>
                                </span>
                                <span class="editTime delTime">
                                    <i class="el-icon-close" @click="delTime(k, j)"></i>
                                </span>
                            </div>
                        </div>
                        <div class="downIcon uk-position-relative">
                            <i class="el-icon-caret-bottom" @click.stop="isChoozeTimeFn(j)"></i>

                            <el-time-picker class="addTime " v-show="item.isChoozeTime" style="width:250px" is-range
                                v-model="item.time" format="HH:mm" value-format="HH:mm" :range-separator="$t('public.to')"
                                :start-placeholder="$t('public.start_time')" :end-placeholder="$t('public.end_time')"
                                :placeholder="$t('integration.select_a_time_range')" @change="editHandleAllFn(item, j)"
                                :ref="`pickers${j}`">
                            </el-time-picker>
                        </div>
                    </div>
                    <div class="timeIcon">
                        <i class="el-icon-plus" @click="addRow"></i>
                        <i class="el-icon-delete" @click="delRow(j)"></i>
                    </div>
                </div>
                <!-- 校验 -->
                <div class="el-form-item__error" v-if="isShowMsg">
                    {{ $t('integration.alarmTime_and_time_point_cannot_be_empty') }}
                </div>
            </el-form-item>
            <el-col :span="24">
                <el-col :span="3">
                    <el-form-item :label="$t('integration.interval_alarm_or_not')" prop="type">
                        <el-checkbox v-model="dioForm.type" :true-label="1" :false-label="0"></el-checkbox>
                    </el-form-item>
                </el-col>

                <el-col :span="6">
                    <!-- 与重复报警勾选互斥 -->
                    <!-- <template v-if="dioForm.type">
                        <el-form-item :label="$t('alarm.repeat_times')" prop="repeatCount">
                            <el-input v-model="dioForm.repeatCount" type="text" style="width:100px"></el-input>
                        </el-form-item>
                    </template> -->
                </el-col>

                <el-col :span="8">
                    <el-form-item :label="$t('integration.alarm_interval')" prop="repeatInterval" class="input-with-select" v-if="dioForm.type">
                        <el-input v-model="dioForm.repeatInterval" type="text" style="width:200px"
                            class="repeat-interval-wrap">
                            <el-select v-model="dioForm.intervalUnit" slot="append" :placeholder="$t('public.please')"
                                style="width:100px" @change="changeUnit">
                                <!-- <el-option :label="$t('integration.second')" :value="0"></el-option> -->
                                <el-option :label="$t('integration.minute')" :value="1"></el-option>
                                <el-option :label="$t('integration.hour')" :value="2"></el-option>
                            </el-select>

                        </el-input>
                        <i class="ml-5 el-icon-question cursor-pointer" :title="$t('integration.the_minimum_unit_of_alarm_interval_is_minutes')"></i>

                    </el-form-item>
                </el-col>
            </el-col>

            <el-col :span="24">
                <el-form-item :label="$t('integration.alarm_strategy')" prop="strategy">
                    <el-select style="width:250px" v-model="dioForm.strategy">
                        <el-option :label="$t(item.title)" :value="parseInt(key)" v-for="(item, key) in alarmStrategy"
                            :key="key"></el-option>
                    </el-select>
                    <i class="el-icon-question cursor-pointer" style="font-size:16px;margin-left: 5px;"
                        v-if="alarmStrategyTip[dioForm.strategy]" :title="$t(alarmStrategyTip[dioForm.strategy].title)"></i>
                </el-form-item>
            </el-col>
        </el-form>
        <div>
            <el-col :span="24">
                <levelContentInput v-bind="$attrs" :LevelContentArray="LevelContentArray" :ContactsList="ContactsList"
                    ref="level" :delayArrayParent="delayArrayParent" />
            </el-col>
        </div>
    </div>
</template>

<script>
import { alarmContactsList } from '@/api/modules/alarm.js';
import { alarmStrategy, alarmStrategyTip } from '@/utils/convert';

import levelContentInput from './levelContentInput.vue';

export default {
    props: ['rangeArray', 'editForm', 'ParenList'],
    components: {
        levelContentInput
    },
    watch: {
        editForm(newVal) {
            newVal.sceneId = String(newVal.sceneId);
            this.dioForm = { ...newVal };
            //  原因的数据改造
            this.dioForm.reason = newVal.reason.split(',');
            // if (this.dioForm.alarmTriggerHierarchyList[0].delay_data) {
            //     let array = JSON.parse(this.dioForm.alarmTriggerHierarchyList[0].delay_data);
            //     this.delayArrayParent = array || [];
            // }
            this.dioForm.alarmTriggerTimeList.forEach(item => {
                this.$set(
                    item,
                    'alarmTimeList',
                    JSON.parse(item.time).map(opt => {
                        return { time: [opt.startTime, opt.endTime], isChoozeTime: false };
                    })
                );
                this.$set(item, 'isChoozeTime', false);
                item.time = '';
            });

            // 层级的数据
            this.LevelContentArray = this.dioForm.alarmTriggerHierarchyList;
        },
        ParenList(newVal) {
            this.ContactsList = [...newVal];
        }
    },
    computed: {
        isShowDialog: {
            get: function () {
                return this.isShow;
            },
            set: function (val) {
                this.$emit('update:isShow', val); // 可以优化成model  或者minx
            }
        },
        /** 用于表示当前登录用户属于什么类型的角色 */
        isSysAdmin() {
            const currentUser = this.$store.getters.userInfo.scope;
            return (currentUser.sysScope && currentUser.sysAdmin) || (currentUser.sysScope && !currentUser.sysAdmin);
        },
        rules() {
            const repeatUnit = (rules, value, callback) => {
                const reg = /^\+?[1-9]\d*$/;
                if (!reg.test(value)) {
                    callback($t('integration.please_enter_an_integer_greater_than_0'));
                } else if (this.dioForm.intervalUnit === 0 && Number(value) < 10) {
                    callback($t('integration.when_the_unit_is_seconds_c__it_cannot_be_less_than_10'));
                } else if ((this.dioForm.intervalUnit === 1 || this.dioForm.intervalUnit === 2) && Number(value) < 1) {
                    callback($t('integration.when_the_unit_is_minute/hour_c__it_cannot_be_less_than_1'));
                } else {
                    callback();
                }
            };
            const alarmTimeFn = (rules, value, callback) => {
                if (this.dioForm.alarmTriggerTimeList.length === 1 && this.dioForm.alarmTriggerTimeList[0].alarmTime === '') {
                    callback($t('integration.select_at_least_one_day_of_alarmTime'));
                } else {
                    let flag = true;
                    for (const item of this.dioForm.alarmTriggerTimeList) {
                        if (item.alarmTimeList.length === 0) {
                            flag = false;
                            break;
                        }
                    }
                    if (!flag) return callback($t('integration.fill_at_least_one_time_point_for_each_item'));
                    callback();
                }
            };
            const numberOverFn = (rules, value, callback) => {
                const reg = /^\+?[1-9]\d*$/;
                if (!reg.test(value)) {
                    callback($t('integration.please_enter_an_integer_greater_than_zero'));
                } else {
                    callback();
                }
            };
            return {
                name: [{ required: true, message: $t('integration.trigger_name_cannot_be_empty'), trigger: 'blur' }],
                sceneId: [{ required: true, message: $t('integration.range_cannot_be_empty'), trigger: 'change' }],
                reason: [{ required: true, message: $t('integration.check_at_least_one_item'), trigger: 'change' }],
                repeatCount: [
                    { required: true, message: $t('integration.repetition_times_cannot_be_empty'), trigger: 'blur' },
                    {
                        trigger: 'blur', // 'change',
                        validator: numberOverFn
                    }
                ],
                repeatInterval: [
                    { required: true, message: $t('integration.repetition_interval_cannot_be_empty'), trigger: 'blur' },
                    {
                        trigger: ['blur'], // 'change',
                        validator: repeatUnit
                    }
                ],
                alarmTime: [
                    {
                        required: true,
                        trigger: ['change'], // 'change',
                        validator: alarmTimeFn
                    }
                ]
            };
        }
    },
    data() {
        return {
            alarmStrategyTip,
            alarmStrategy,
            LevelContentArray: [],
            dioForm: {
                name: '',
                sceneId: '',
                type: 0,
                strategy: 1,
                reason: [],
                repeatInterval: '',
                intervalUnit: 1,
                alarmTriggerTimeList: [
                    {
                        alarmTime: '',
                        time: '',
                        isChoozeTime: false,
                        alarmTimeList: []
                    }
                ]
            },
            reasonArray: [
                {
                    type: '0',
                    label: this.$t('device.conn_abnormal'),
                    delay_num: '0',
                    unit: 0
                },
                {
                    type: '1',
                    label: $t('public.ex_data'),
                    delay_num: '0',
                    unit: 0
                },
                {
                    type: '2',
                    label: $t('public.ex_power'),
                    delay_num: '0',
                    unit: 0
                }
            ],
            weekDay: [
                {
                    value: 1,
                    label: $t('public.monday')
                },
                {
                    value: 2,
                    label: $t('public.tuesday')
                },
                {
                    value: 3,
                    label: $t('public.wednesday')
                },
                {
                    value: 4,
                    label: $t('public.thursday')
                },
                {
                    value: 5,
                    label: $t('public.friday')
                },
                {
                    value: 6,
                    label: $t('public.saturday')
                },
                {
                    value: 7,
                    label: $t('public.sunday')
                }
            ],
            ContactsList: [],
            // 传递给子级的异常数据
            delayArrayParent: [],
            isShowMsg: false,
            // 记录上一次的范围id
            oldScopeId: ''
        };
    },
    created() { },
    methods: {
        changeUnit() {
            this.$refs.form.validateField('repeatInterval');
        },
        goBack() {
            this.$emit('goBack');
        },
        visibleChange(bool) {
            if (bool) {
                this.oldScopeId = this.dioForm.sceneId;
            }
        },
        changeRangeFn(id) {
            if (this.ContactsList.length > 0) {
                this.$confirm(this.$t($t('integration.this_operation_will_clear_the_alarm_object_and_its_contacts')))
                    .then(() => {
                        alarmContactsList({ sceneId: id }).then(({ result }) => {
                            this.ContactsList = result;
                        });
                        this.$refs.level.resetFn(true);
                        // this.dioForm.reason = [];
                    })
                    .catch(() => {
                        this.dioForm.sceneId = this.oldScopeId;
                    });
            } else {
                alarmContactsList({ sceneId: id }).then(({ result }) => {
                    this.ContactsList = result;
                });
            }
        },
        isChoozeTimeFn(j) {
            this.$refs[`pickers${j}`][0].$el.click();

            this.dioForm.alarmTriggerTimeList[j].isChoozeTime = !this.dioForm.alarmTriggerTimeList[j].isChoozeTime;
            this.dioForm.alarmTriggerTimeList[j].alarmTimeList.forEach((item, index) => {
                item.isChoozeTime = false;
            });
        },
        addRow() {
            if (this.dioForm.alarmTriggerTimeList.length > 7) return this.$message.warning($t('integration.up_to_seven_record_times'));
            this.dioForm.alarmTriggerTimeList.push({
                alarmTime: '',
                isChoozeTime: false,
                alarmTimeList: []
            });
        },
        delRow(index) {
            if (this.dioForm.alarmTriggerTimeList.length === 1) return this.$message.warning($t('integration.keep_at_least_one_piece_of_data'));
            this.dioForm.alarmTriggerTimeList.splice(index, 1);
        },
        // 与报警对象联动
        changeFn(e, item) {
            this.$refs.level.opteraData(e, item);
            // const array = [...this.dioForm.alarmTriggerHierarchyList]
            // if (e) {
            //     //     // 连接异常
            //     switch (String(item.type)) {
            //         case '0':
            //             {
            //                 this.delayArrayParent = array.map(item => {
            //                     item.delay_data.push({
            //                         delay_num: 0,
            //                         type: 0,
            //                         unit: 0
            //                     })
            //                     return item
            //                 })
            //                 break;
            //             }
            //         case '1':
            //             {
            //                 this.delayArrayParent = array.map(item => {
            //                     item.delay_data.push({
            //                         delay_num: 0,
            //                         type: 1,
            //                         unit: 0
            //                     })
            //                     return item
            //                 })
            //                 break;
            //             }
            //         case '2':
            //             {
            //                 this.delayArrayParent = array.map(item => {
            //                     item.delay_data.push({
            //                         delay_num: 0,
            //                         type: 2,
            //                         unit: 0
            //                     })
            //                     return item
            //                 })
            //                 break;
            //             }
            //         default:
            //             break;
            //     }
            // } else {
            //     // 删除
            //     this.delayArrayParent = array.map(opt => {
            //         console.log(opt);
            //         let newArray = typeof opt.delay_data === 'string' ? JSON.parse(opt.delay_data) : opt.delay_data;
            //         opt.delay_data = newArray.filter(row => row.type + '' !== item.type)
            //         return opt
            //     })
            // }
        },
        handleConfrimFn(startTime, endTime, array) {
            let flag = true;
            for (const item of array || []) {
                if (item.endTime === endTime || item.startTime === startTime) {
                    flag = false;
                    break;
                }
            }
            return flag;
        },
        editHandleFn(option, j, k) {
            this.dioForm.alarmTriggerTimeList[j].isChoozeTime = false;
            option.isChoozeTime = true;
            if (option.isChoozeTime) {
                this.$nextTick(() => {
                    this.$refs[`pickers${j}_${k}`][0].$el.click();
                });
            }
            this.dioForm.alarmTriggerTimeList[j].alarmTimeList.forEach((item, index) => {
                index !== k ? (item.isChoozeTime = false) : true;
            });
        },
        editHandleAllFn(item, j) {
            // 遗漏  时间不能存在交集
            let flatArray = [];
            if (this.dioForm.alarmTriggerTimeList[j].alarmTimeList.length > 0) {
                flatArray = this.dioForm.alarmTriggerTimeList[j].alarmTimeList
                    .map(item => {
                        return item.time;
                    })
                    .flat(2);
            }

            if (flatArray.includes(item.time[0]) || flatArray.includes(item.time[1])) return this.$message.warning($t('integration.the_same_time_point_cannot_exist'));
            if (!item.time) return;
            this.dioForm.alarmTriggerTimeList[j].alarmTimeList.push({
                isChoozeTime: false,
                time: item.time
            });
        },
        delTime(k, j) {
            if (this.dioForm.alarmTriggerTimeList[j].alarmTimeList.length === 1) return this.$message.warning($t('integration.keep_at_least_one_point_in_time'));
            this.dioForm.alarmTriggerTimeList[j].alarmTimeList.splice(k, 1);
        },
        clearValidate() {
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
        },
        async justify() {
            this.$refs.level.justify();
            // 校验成功则方法自动返回true，校验方法报错则说明校验失败，返回false
            try {
                return await this.$refs.form.validate();
            } catch (error) {
                return false;
            }
        },
        resetFn() {
            this.dioForm = {
                name: '',
                sceneId: '',
                type: 0,
                reason: [],
                repeatInterval: '',
                intervalUnit: 1,
                alarmTriggerTimeList: [
                    {
                        alarmTime: '',
                        startTime: '',
                        endTime: '',
                        isChoozeTime: false,
                        alarmTimeList: []
                    }
                ]
            };
            this.delayArrayParent = [];
            this.ContactsList = [];
            this.clearValidate();
            this.$refs.level.resetFn();
        },
        closeTimeSelect(e) {
            // 判断点击目标  如果是时间范围选择则不做响应
            if (e.target.getAttribute('class') === 'el-range-input') {
                return;
            }
            for (let j = 0; j < this.dioForm.alarmTriggerTimeList.length; j++) {
                this.dioForm.alarmTriggerTimeList[j].isChoozeTime = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
$border-color: #dcdfe6;

.content {
    height: 650px;
    overflow: auto;

    i {
        color: var(--primary-color);
    }
}

.reasonClass {
    display: flex;

    .reasonRontent {
        border: 1px solid var(--primary-color);
        height: 30px;
        margin-right: 15px;
        // box-sizing: border-box;
        display: flex;
        border-radius: 2px;
    }

    .textDiv {
        background-color: var(--primary-color);
        color: #fff;
        font-size: 14px;

        padding: 0 15px;
    }

    .m5 {
        margin: 0 1px 0 5px;

        .el-checkbox {
            box-sizing: border-box;
            margin-left: 4px;
        }
    }
}

.alarmTime {
    min-height: 30px;

    display: flex;

    .timePoint {
        height: 100%;
        flex: 1;
        max-width: 650px;
        margin-left: 5px;
        display: flex;

        .pointContent {
            border: 1px solid $border-color;
            border-top-left-radius: $border-color;
            border-bottom-left-radius: $border-color;
            min-height: 30px;
            flex: 1;
            display: flex;
            padding-top: 1px;
            flex-wrap: wrap;
            align-items: center;
            align-content: flex-start;

            .m5 {
                margin: 0px 5px;
                border: var(--primary-color) solid 1px;
                box-sizing: border-box;
            }

            .time {
                display: inline-block;
                text-align: center;
                width: 50px;
                height: 100%;
                background-color: var(--primary-color);
                color: #fff;
            }

            .editTime {
                display: inline-block;
                text-align: center;
                width: 30px;
                background-color: #fff;

                color: var(--primary-color);
                height: 100%;
                cursor: pointer;
                position: relative;

                &:hover {
                    background-color: #e7e7e7;
                }

                .timeChooze {
                    position: absolute;
                    top: 0px;
                    z-index: 999;
                    left: -27px;
                    visibility: hidden;
                }
            }

            .delTime {
                border-left: var(--primary-color) solid 1px;

                &:hover {
                    background-color: #ffacac;
                }
            }
        }

        .downIcon {
            width: 34px;
            height: 34px;
            line-height: 34px;
            border-top: 1px solid $border-color;
            border-right: 1px solid $border-color;
            border-bottom: 1px solid $border-color;
            border-top-right-radius: 2px;
            border-bottom-right-radius: 2px;
            box-sizing: border-box;
            text-align: center;
            // position: relative;

            // .timeChooze {
            //     position: absolute;
            //     top: 34px;
            //     z-index: 999;
            //     right: -265px;
            //     width: 300px;
            //     height: 38px;
            //     box-sizing: border-box;
            //     // border: 1px solid var(--primary-color);
            // }

            i {
                font-size: 24px;

                &:hover {
                    cursor: pointer;
                }
            }

            .addTime {
                position: absolute;
                top: 0px;
                z-index: 999;
                left: -27px;
                visibility: hidden;
            }
        }
    }

    .timeIcon {
        margin: 0 10px;

        i {
            font-size: 14px;
            font-weight: bold;
            margin: 0 5px;

            &:hover {
                cursor: pointer;
            }
        }
    }

    ::v-deep .el-input--mini .el-input__inner {
        height: 34px !important;
        font-size: 14px;
    }
}

.mt38 {
    margin-top: 15px;
}

// .timeClass {
//     display: flex;
//     height: 100%;
//     width: 100%;

//     .timehour,
//     .timemin {
//         flex: 1;
//         padding: 0 5px;
//         // padding-top: 4px;
//     }

//     .checkIcon {
//         width: 40px;
//         height: 100%;
//         text-align: center;
//         line-height: 38px;
//         border-left: 1px solid #ccc;
//     }

//     .maohao {
//         line-height: 38px;
//     }

//     ::v-deep .el-input--mini .el-input__inner {
//         height: 30px !important;
//     }
// }

.input-with-select {
    ::v-deep .el-input__inner {
        font-size: 14px;
    }
}

::v-deep .el-input-group__append {
    background-color: #fff;
}

::v-deep .el-divider--horizontal {
    margin: 10px 0;
}

::v-deep.repeat-interval-wrap {
    .el-input__inner {
        border-radius: 0 0 2px 2px !important;
    }

    .el-input-group__append {
        border: 2px 2px 0 0;
    }
}
</style>
